export default function Racing() {
  return (
    <section id="racing" className="py-24 bg-gradient-to-br from-slate-50 to-slate-100">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            Racing Programs
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            Experience the adrenaline rush of competitive sailing with our professional racing programs designed for all skill levels
          </p>
        </div>

        <div className="relative rounded-2xl overflow-hidden shadow-2xl">
          <div className="relative h-96 w-full">
            <img
              src="https://static.readdy.ai/image/46842361a9a2459ecf5ba33a5b883dd8/bda3438b0fa1a4cf3a83612879ce5551.jpeg"
              alt="Racing"
              className="w-full h-full object-cover object-center"
            />
            <div className="absolute inset-0 bg-gradient-to-r from-black/70 to-black/30"></div>
          </div>
          <div className="absolute inset-0 flex items-center">
            <div className="max-w-2xl px-12">
              <h3 className="text-4xl font-bold text-white mb-4">
                Feel the Rush of Competition
              </h3>
              <p className="text-xl text-white/95 mb-6">
                Ready to race? Give us a call to get started.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
